import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXSimpleListingSearch implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxSimpleSearchContainer";
    }
    render(){
        // console.log("simple search");

    }
}